module.exports = __webpack_public_path__ + "img/5.b994f30e.jpg";